import { useEffect, useState } from 'react'
import { Minimize2, Power, X } from 'lucide-react'

// Masaüstünde pencere çarpısına basılınca Rust 'close-requested' olayı gönderir.
// Burada onay dialog'u gösterilir:
//  - Tepsiye küçült: pencere gizlenir, API/sunucu arka planda çalışmaya devam eder.
//  - Çıkış: API durdurulur ve uygulama tamamen kapanır.
//  - İptal: hiçbir şey yapılmaz.
export default function CloseConfirm() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    let unlisten: (() => void) | undefined
    ;(async () => {
      try {
        const { listen } = await import('@tauri-apps/api/event')
        unlisten = await listen('close-requested', () => setOpen(true))
      } catch {
        /* Tauri yoksa sessiz geç */
      }
    })()
    return () => { unlisten?.() }
  }, [])

  async function tepsiyeKucult() {
    setOpen(false)
    try {
      const { invoke } = await import('@tauri-apps/api/core')
      await invoke('hide_to_tray')
    } catch { /* yoksay */ }
  }

  async function cikis() {
    // Tam çıkış → oturumu kapat ki yeniden açılışta login ekranı gelsin.
    try { localStorage.removeItem('inova-auth') } catch { /* yoksay */ }
    try {
      const { invoke } = await import('@tauri-apps/api/core')
      await invoke('quit_app')
    } catch { /* yoksay */ }
  }

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60">
      <div className="w-full max-w-sm bg-bg-surface rounded-xl border border-bg-border shadow-lg p-6 space-y-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-warning/15 flex items-center justify-center shrink-0">
            <Power className="w-5 h-5 text-warning" />
          </div>
          <div>
            <h2 className="text-base font-semibold text-text-primary">Programdan çıkılsın mı?</h2>
            <p className="text-sm text-text-secondary mt-1 leading-relaxed">
              Tepsiye küçültürseniz sunucu ve veritabanı arka planda çalışmaya devam eder.
              Çıkarsanız sunucu durur ve bağlı istemciler bağlanamaz.
            </p>
          </div>
        </div>

        <div className="space-y-2">
          <button
            onClick={tepsiyeKucult}
            className="w-full flex items-center gap-2.5 px-4 py-2.5 rounded-lg bg-bg-elevated border border-bg-border text-sm font-medium text-text-primary hover:border-primary/50 transition-colors"
          >
            <Minimize2 className="w-4 h-4 text-primary" />
            Tepsiye küçült <span className="text-text-muted font-normal">(önerilen)</span>
          </button>
          <button
            onClick={cikis}
            className="w-full flex items-center gap-2.5 px-4 py-2.5 rounded-lg bg-error/10 border border-error/30 text-sm font-medium text-error hover:bg-error/15 transition-colors"
          >
            <Power className="w-4 h-4" />
            Çıkış (sunucuyu durdur)
          </button>
          <button
            onClick={() => setOpen(false)}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm text-text-secondary hover:text-text-primary hover:bg-bg-elevated transition-colors"
          >
            <X className="w-4 h-4" />
            İptal
          </button>
        </div>
      </div>
    </div>
  )
}
